import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the record table bets report view.
 */
export default class recordTableBetsReportView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function

        // Window for displaying ticket details
        const filterDetails = webix.ui({
            view: 'window',
            move: true,
            id: 'filterDetails2',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    {
                        view: 'label',
                        label: _('Detalles del Ticket'), // Ticket details label
                        align: 'center',
                    },
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            this.getTopParentView().hide(); // Hide window on click
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'datatable', // Data table for ticket details
                id: 'dtDetails2',
                css: 'webix_header_border webix_data_border webix_footer_border',
                select: true,
                columns: [
                    {
                        id: 'Id',
                        header: _('Ticket Det Id'), // Column header for Ticket Det Id
                        width: 100,
                        sort: 'int', // Sorting type
                    },
                    {
                        id: 'TicketId',
                        header: _('Ticket ID'), // Column header for Ticket ID
                        width: 100,
                        sort: 'int',
                    },
                    {
                        id: 'Description',
                        header: _('Descripción'), // Column header for Description
                        width: 350,
                        sort: 'int',
                    },
                    {
                        id: 'Market',
                        header: _('Market'), // Column header for Market
                        width: 200,
                        sort: 'int',
                    },
                    { id: 'Option', header: 'Option', width: 200, sort: 'int' }, // Column header for Option
                    {
                        id: 'Odds',
                        header: _('Odds'), // Column header for Odds
                        width: 100,
                        format: webix.i18n.numberFormat, // Number formatting
                        sort: 'int',
                    },
                ],
            },
        });

        // Main data table configuration
        return {
            view: 'datatable',
            css: 'webix_header_border webix_data_border webix_footer_border',
            select: true,
            scrollY: screen.width < 820 ? false : true, // Conditional vertical scrolling
            columns: [
                {
                    id: 'Id',
                    header: _('Ticket Det Id'), // Column header for Ticket Det Id
                    width: 100,
                    sort: 'int',
                },
                {
                    id: 'TicketId',
                    header: _('Ticket ID'), // Column header for Ticket ID
                    width: 100,
                    sort: 'int',
                },
                {
                    id: 'Description',
                    header: _('Descripción'), // Column header for Description
                    width: 350,
                    sort: 'int',
                },
                { id: 'Market', header: _('Market'), width: 200, sort: 'int' }, // Column header for Market
                { id: 'Option', header: 'Option', width: 200, sort: 'int' }, // Column header for Option
                {
                    id: 'Odds',
                    header: _('Odds'), // Column header for Odds
                    width: 100,
                    format: webix.i18n.numberFormat, // Number formatting
                    sort: 'int',
                },
            ],
            loadahead: 0, // Load ahead configuration
            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch configuration
            pager: 'pagerA', // Pager ID
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The data table grid.
     */
    init(grid) {
        var url = devConfig.geturlApi() + 'null/Report/GetBetHistoryDetail'; // API URL for fetching bet history details
        this.on(this.app, 'user:id', (idUser) => {
            grid.load(url + '?id=' + idUser); // Load grid data based on user ID
            $$('dtDetails2').clearAll(); // Clear previous details
            $$('dtDetails2').load(url + '?id=' + idUser); // Load details for the selected user
        });
        // Event listener for item click in the grid
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('casinoTransDetail:select', [item]); // Trigger event with selected item
        });
    }
}

// FILE DOCUMENTED
